var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    enableBackground: "new 0 0 21 21",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5463E",
    d: "M9.747,0h1.5c5.38,0.006,9.741,4.367,9.747,9.747c0,0.414-0.336,0.75-0.75,0.75H0.75 c-0.415,0-0.75-0.336-0.75-0.75C0.006,4.367,4.367,0.006,9.747,0z M9.747,1.5C5.484,1.505,1.926,4.753,1.533,8.998h17.928 C19.068,4.753,15.51,1.505,11.247,1.5H9.747z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5463E",
    d: "M17.245,14.996h2.999c0.414,0,0.75,0.336,0.75,0.75v1.499c-0.002,2.069-1.68,3.747-3.749,3.749H3.749 C1.68,20.992,0.002,19.314,0,17.245v-1.499c0-0.414,0.335-0.75,0.75-0.75h10.496c0.163,0,0.32,0.053,0.451,0.149l2.549,1.912 l2.549-1.912C16.926,15.049,17.083,14.996,17.245,14.996z M17.245,19.494c1.242,0,2.249-1.007,2.249-2.249v-0.749h-2l-2.799,2.099 c-0.266,0.2-0.633,0.2-0.899,0l-2.799-2.099H1.5v0.749c0,1.242,1.007,2.249,2.25,2.249H17.245z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5463E",
    d: "M20.244,11.996H0.75c-0.415,0-0.75,0.336-0.75,0.75s0.335,0.75,0.75,0.75h19.494 c0.414,0,0.75-0.336,0.75-0.75S20.658,11.996,20.244,11.996z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5463E",
    d: "M6.748,4.499c-0.414,0-0.75,0.335-0.75,0.75v0.75c0,0.414,0.335,0.75,0.75,0.75s0.75-0.335,0.75-0.75v-0.75 C7.498,4.834,7.162,4.499,6.748,4.499z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5463E",
    d: "M10.497,4.499c-0.414,0-0.75,0.335-0.75,0.75v0.75c0,0.414,0.336,0.75,0.75,0.75s0.75-0.335,0.75-0.75v-0.75 C11.247,4.834,10.911,4.499,10.497,4.499z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5463E",
    d: "M14.246,4.499c-0.414,0-0.75,0.335-0.75,0.75v0.75c0,0.414,0.336,0.75,0.75,0.75s0.75-0.335,0.75-0.75v-0.75 C14.996,4.834,14.66,4.499,14.246,4.499z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenorders);
export default __webpack_public_path__ + "static/media/openorders.56d9a883aeaf167a51977095d4da1886.svg";
export { ForwardRef as ReactComponent };